import React from "react";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import "./404.scss";

const Four04 = () => {
  return (
    <AppWrapper id="four04" pageTitle="404 Page Not Found">
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h1>Page Not Found</h1>
          <p className="lead">The page your requested does not exist!</p>
        </div>
      </div>
    </AppWrapper>
  );
};

export default Four04;
